export const AVAILABLE_LANGUAGES = [
  { name: 'locale.cs', id: 'cs' },
  { name: 'locale.en', id: 'en' },
  { name: 'locale.pl', id: 'pl' },
]
